// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = module.exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".d2-badge[data-v-7e9ccabd] {\n  margin-bottom: 20px;\n}\n.d2-badge p[data-v-7e9ccabd] {\n  margin: 0px;\n  margin-bottom: 2px;\n}\n.d2-badge p[data-v-7e9ccabd]:last-child {\n  margin-bottom: 0px;\n}\n.d2-badge p img[data-v-7e9ccabd] {\n  display: inline-block;\n  margin: 0px 2px;\n}", ""]);
